import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    customer: {
		id: 0,
		name: ''
	},
    auth: {
      valid: false,
      user_id: 0,
      admin: false,
      cc_col_visible: false
    },
    import: {},
    lang: {
      default: 'de',
      loaded: []
    }
  },
  mutations: {
    login (state, p) {
      state.auth.valid = true
      state.auth.user_id = p.user_id
      state.auth.admin = p.is_admin,
      state.auth.cc_col_visible = p.cc_col_visible
    },
    logout (state) {
      // console.log('mutations -> logout')
      state.auth.valid = false
      state.auth.user_id = 0
      state.auth.admin = false
      state.auth.cc_col_visible = false
      state.customer.id = 0
      state.customer.name = ''
    },
    set_import_param (state, v) {
		state.import = v
    }
  }
})

export default store
